import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const style = {
  position: 'fixed',
  top: "50px",
  bottom: "50px",
  right: '50px',
  margin: "auto",
  // transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function TransitionsModal({ hanldeModalSubsOpen, openModalSubs, subOneItems, subTwoItems }) {
  const [subTwoShow, setSubTwoShow] = React.useState(true)

  return (
    <Box sx={{ ...style, display: openModalSubs ? "block" : "none" }}>
      <div className="tab">
        <button className="tablinks" onClick={() => { setSubTwoShow(false) }}>زیرنویس اول</button>
        <button className="tablinks" onClick={() => { setSubTwoShow(true) }}>زیرنویس دوم</button>
        <button className="tablinks" onClick={() => { hanldeModalSubsOpen(false) }}>بستن</button>
      </div>
      {subTwoShow ?
        <div style={{ height: "100%", overflow: "scroll" }} >
          {subTwoItems.map((el, idx) => (
            <div key={`sub1-${idx}`} style={{ direction: "ltr" }}>
              <span style={{ paddingRight: "20px" }}>{el.id}</span>
              <span>{el.text}</span>
              <hr />
            </div>
          ))
          }

        </div>
        :
        <div style={{ height: "100%", overflow: "scroll" }} >
          {subOneItems.map((el, idx) => (
            <div key={`sub2-${idx}`} style={{ direction: "ltr" }}>
              <span style={{ paddingRight: "20px" }}>{el.id}</span>
              <span>{el.text}</span>
              <hr />
            </div>
          ))
          }

        </div>}




    </Box>
  );
}